<template>
	<a-modal :title="isUpdate ? '修改关键词' : '新增关键词'" :width="640" :visible="visible" :confirmLoading="false"
		:maskClosable="false" @ok="handleOk" @cancel="handleCancel">
		<a-spin :spinning="loading">
			<a-form-model ref="adminForm" :model="form" :label-col="{span:6}" :wrapper-col="{span:14}" autoComplete="off">
				<a-form-model-item v-show="false" label="ID" prop="id">
					<a-input type="hidden" v-model.number="form.id" />
				</a-form-model-item>
				<a-form-model-item label="类型" prop="type"
					:rules="[{ required: true, message: '必填，不能为空', trigger: 'change' }]">
					<a-select v-model="form.type" style="width:160px" placeholder="请选择">
						<a-select-option
							v-for="item in violateTypeOptions"
							:key="item.value"
							:value="item.value"
						>{{ item.label }}</a-select-option>
					</a-select>
				</a-form-model-item>

				<a-form-model-item
					v-if="isUpdate"
					label="关键词"
					prop="word"
					:rules="[
						{ required: true, message: '必填，不能为空', trigger: 'blur' },
						{ max: 100, message: '不能超过100个字符', trigger: 'blur' },
						{ validator: isExistWord, trigger: 'blur' }
					]"
				>
					<a-input v-model="form.word" placeholder="请输入关键词" allow-clear />
					<span style="color:#acacac">
						注意：修改时只能修改一个关键词
					</span>
				</a-form-model-item>

				<a-form-model-item
					v-else
					label="关键词"
					prop="words"
					:rules="[
						{ required: true, message: '必填，不能为空', trigger: 'blur' }
					]"
				>
					<a-textarea v-model="form.words" :auto-size="{minRows:12, maxRows:50}" />
					<span style="color:#acacac">
						注意：一行一个关键词，提交前会校验是否已存在
					</span>
				</a-form-model-item>
			</a-form-model>
		</a-spin>
	</a-modal>
</template>

<script>
	import pick from 'lodash.pick';
	import { dictList } from "@/utils/dictTrans.js";
	import { violateWordIsExist } from '@/api/op/violateWord';

	const ADD_FIELDS = ['id', 'type', 'words'];
	const UPDATE_FIELDS = ['id', 'type', 'word'];

	const VIOLATE_TYPE_OPTIONS = dictList('violateType');
	const DEFAULT_VIOLATE_TYPE = VIOLATE_TYPE_OPTIONS.length > 0 ? VIOLATE_TYPE_OPTIONS[0].value : undefined;

	function emptyForm() {
		return {
			id: 0,
			type: DEFAULT_VIOLATE_TYPE,
			word: '',
			words: ''
		};
	}

	export default {
		props: {
			visible: {
				type: Boolean,
				required: true
			},
			loading: {
				type: Boolean,
				default: () => false
			},
			model: {
				type: Object,
				default: () => null
			}
		},
		data() {
			return {
				form: emptyForm(),
				violateTypeOptions: VIOLATE_TYPE_OPTIONS,
			}
		},
		created() {
			this.unwatch = this.$watch('model', (newVal) => {
				if (!newVal) {
					this.initForm();
					return;
				}

				this.$nextTick(() => {
					const isUpdate = !!(newVal && newVal.id > 0);
					const fields = isUpdate ? UPDATE_FIELDS : ADD_FIELDS;
					const base = pick(newVal, fields);
					this.form = { ...emptyForm(), ...base };
					if (this.form.type === undefined || this.form.type === null || this.form.type === '') {
						this.form.type = DEFAULT_VIOLATE_TYPE;
					} else {
						const numType = Number(this.form.type);
						if (!Number.isNaN(numType)) {
							this.form.type = numType;
						}
					}
					if (this.$refs.adminForm) {
						this.$refs.adminForm.clearValidate();
					}
				});
			}, {
				immediate: true
			});
		},
		computed: {
			isUpdate: function() {
				return this.model && this.model.id > 0 ? true : false;
			}
		},
		methods: {
			initForm() {
				this.form = emptyForm();
				this.$nextTick(() => {
					if (this.$refs.adminForm) {
						this.$refs.adminForm.clearValidate();
					}
				});
			},
			handleOk() {
				this.$emit('ok');
			},
			handleCancel() {
				this.$emit('cancel');
				this.resetState();
			},
			resetState() {
			},
			isExistWord(rule, value, callback) {
				if (!value) {
					callback();
					return;
				}
				if (this.model && this.model.word === value) {
					callback();
					return;
				}
				violateWordIsExist(value).then(res => {
					if (res.data) {
						callback(new Error('该关键词已存在'));
					} else {
						callback();
					}
				}).catch(() => callback());
			},
		}
	}
</script>

<style scoped>
	.ant-input-number-handler-wrap :deep(.ant-input-number-handler-wrap) {
		display: none;
	}
</style>
